import type { AsyncOptionGroup } from '@/shared/config/funnel/async-options/types';

export function filterGroups(groups: AsyncOptionGroup[], query: string): AsyncOptionGroup[] {
  if (!query.trim()) return groups;
  const q = query.toLowerCase();
  return groups
    .map(g => ({
      ...g,
      options: g.options.filter(o => o.label.toLowerCase().includes(q)),
    }))
    .filter(g => g.options.length > 0);
}

export function flattenOptions(groups: AsyncOptionGroup[]): AsyncOptionGroup['options'] {
  return groups.flatMap(g => g.options);
}
